import React from 'react';
import {
  withLoading,
  useTranslator,
  MeasurementHistoryConnectorApollo,
  PERIOD_LENGTH,
  PERIOD_END,
  MEASUREMENT_TYPES,
} from '@front-activerse/common-components';
import { Button, Col, Container, Row, Alert } from 'reactstrap';
import Layout from '../../Layout/Layout';
import { Link } from 'react-router-dom';
import CurrentMeasurementsContainer from './CurrentMeasurements/CurrentMeasurementsContainer';
import MeasurementHistoryContainer from './MeasurementHistory/MeasurementHistoryContainer';
import TitleBar from '../../Layout/TitleBar';
import UniversalPlaceholder from '../../Layout/UniversalPlaceholder';
import { IMeasurement } from '../types';

interface IMeasurementContainerProps {
  weight: IMeasurement;
  hip: IMeasurement;
  waist: IMeasurement;
  thigh: IMeasurement;
  rightthigh: IMeasurement;
  arm: IMeasurement;
  rightarm: IMeasurement;
  chest: IMeasurement;
  bodyFat: IMeasurement;
  muscleMass: IMeasurement;
  visceralFat: IMeasurement;
  systemOfMeasures: string;
  availableMeasurements: string[][];
  paths: {
    PATH_MEASUREMENT: string;
    PATH_MEASUREMENT_ADD: string;
    PATH_MEASUREMENT_EDIT: string;
  };
}

const MeasurementsContainer: React.FC<IMeasurementContainerProps> = ({
  weight,
  hip,
  waist,
  thigh,
  rightthigh,
  arm,
  rightarm,
  chest,
  bodyFat,
  muscleMass,
  visceralFat,
  systemOfMeasures,
  availableMeasurements,
  paths,
}) => {
  const { t } = useTranslator();
  return (
    <Layout>
      <TitleBar showBackBtn={false}>{t('measurements.navbarTitle')}</TitleBar>
      <section className="page-template-measurements full-height3a">
        <Container className="py-md-4">
          <Row>
            <Col md={{ size: 10, offset: 1 }}>
              <div className="measurements-container">
                <Alert color="info" className="alert-wide" fade={false}>
                  <p className="small">{t('addMesurement.notification.content')}</p>
                  <div className="text-center">
                    <Button
                      color="primary"
                      size="sm"
                      tag={Link}
                      // to={{
                      //   pathname: paths.PATH_MEASUREMENT_ADD,
                      //   state: {
                      //     from: {
                      //       pathname: paths.PATH_MEASUREMENT,
                      //     },
                      //   },
                      // }}
                      to={paths.PATH_MEASUREMENT_ADD}
                      state={{
                        from: {
                          pathname: paths.PATH_MEASUREMENT,
                        },
                      }}
                    >
                      {t('addMesurement.notification.button')}
                    </Button>
                  </div>
                </Alert>

                <Row>
                  <Col md="6">
                    <CurrentMeasurementsContainer
                      currentMeasurements={{
                        weight,
                        hip,
                        waist,
                        thigh,
                        rightthigh,
                        arm,
                        rightarm,
                        chest,
                        bodyFat,
                        muscleMass,
                        visceralFat,
                      }}
                      availableMeasurements={availableMeasurements}
                      pathsMeasurementEdit={paths.PATH_MEASUREMENT_EDIT}
                    />
                  </Col>
                  <Col md="6">
                    <MeasurementHistoryConnectorApollo
                      initialMeasurementType={MEASUREMENT_TYPES.WEIGHT}
                      periodLength={PERIOD_LENGTH}
                      periodEnd={PERIOD_END}
                    >
                      {(measurementHistoryData: any) => (
                        <MeasurementHistoryContainer
                          {...measurementHistoryData}
                          pathsMeasurementEdit={paths.PATH_MEASUREMENT_EDIT}
                          availableMeasurements={availableMeasurements}
                        />
                      )}
                    </MeasurementHistoryConnectorApollo>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </Layout>
  );
};

const Placeholder = () => <UniversalPlaceholder titleBar="measurements.navbarTitle" />;

export default withLoading(MeasurementsContainer, Placeholder);
